"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateManagementModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
class StateManagementModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.StateManagementModuleId, ModuleConstants.StateManagementFriendlyName, 'assignment', 'StateManagementPopup', 'Manages Adaptable State, User State and Predefined Config', api);
    }
}
exports.StateManagementModule = StateManagementModule;
